const utils             = require('../../../lib/utils')
const popoverController = require('../../../lib/controllers/popover')

module.exports = {
    model: {
        // config: {
        //     "fields": {
        //         "setAndCopy": {
        //             "disabled": true // set and copy usage granted?
        //         },
        //         "setAndSendViaMail": {
        //             "disabled": false // sendViaMail usage granted?
        //         },
        //         "setAndSendViaSMS": {
        //             "disabled": false // sendViaSMS usage granted?
        //         },
        //         "passwordGenerator": {
        //             "fields": {
        //                 "noChange": { // default type if no "defaultType" is set to indicate that there will be no change.
        //                     ...
        //                 },
        //                 "password": {
        //                     "disabled": true // set password manually granted?
        //                 },
        //                 "generatePasswordOfLength": {
        //                     "disabled": false,    // generate password granted?
        //                     "min": 8,            // min length of password
        //                     "max": 16,           // max length of password
        //                 }
        //             },
        //             "defaultType": "generatePasswordOfLength" // which type should be selected by default?
        //         }
        //     },
        //     "separatedFieldCodes": {
        //         "code": "code",
        //         "passwordMeta": "passwordMeta",
        //         "passwordSetAt": "passwordSetAt",
        //         "passwordSentViaSMSAt": "passwordSentViaSMSAt",
        //         "passwordSentViaMailAt": "passwordSentViaMailAt"
        //     }
        // }
        dataJSON: {}
    },

    events: {
        controls: {
            type: 'click',
            selector: 'button',
            action: function(event){
                event.stopImmediatePropagation()
                const self = event.data.component
                const $target = $(event.target).closest('button')
                const fieldType = $target.data('fieldType')

                if(fieldType === 'resetPassword'){
                    self.showPasswordResetOptions($target, 'button[data-field-type="resetPassword"]')
                }
            }
        },

        onChange: {
            type: 'change',
            action: function(event){
                event.preventDefault()
                event.stopImmediatePropagation()

                const self = event.data.component
                self.updateValue(self.$.find('input[type="text"]').val(), true)
            }
        },
    },

    methods: {
        toggleSendConfirmation(){
            this.triggerClosest('onChildChanged', {
                fieldCode: 'emailMeta',
                value: {
                    sendEmailConfirmation: true
                }
            })
        },

        showPasswordResetOptions($button, triggerSelector){
            return this.performAndStoreAction(
                'showPasswordResetOptions_inEffect',
                this.prepareAction(popoverController.getPopoverAction($button, triggerSelector), undefined, undefined, {
                    source: {
                        container: {
                            componentData: {
                                config: {
                                    orientation: 'SE-NE',
                                    autoOpen: true,
                                    preventFirstFocusOut: true,
                                    distance: {
                                        y: '10px'
                                    }
                                }
                            }
                        },
                        content: {
                            componentData: {
                                component: [
                                    'base',
                                    'form',
                                    'fields',
                                    'userAndPasswordOptions',
                                ],
                                model: {
                                    config: {
                                        fields: (this.model.config || {}).fields || {}
                                    }
                                }
                            }
                        }
                    }
                })
            )
        },

        updatePasswordMeta(passwordMeta){
            let valueChanged = false
            if(passwordMeta !== undefined){
                valueChanged = !utils.isEqual(this.model.dataJSON.passwordMeta, passwordMeta)
                this.model.dataJSON.passwordMeta = passwordMeta
            }

            if(valueChanged){
                if(this.model.dataJSON.passwordMeta !== undefined){
                    this.triggerClosest('onChildChanged', {
                        fieldCode: this.model.fieldCode,
                        value: this.model.dataJSON
                    })
                }
            }
        },

        updateValue: function(value, tellParents){
            let valueChanged = false
            if(value !== undefined){
                if(!value) value = null;
                valueChanged = this.model.dataJSON.code !== value
                this.model.dataJSON.code = value
            }

            if(valueChanged){
                if(tellParents && this.model.dataJSON.code !== undefined){
                    if(!this.model.dataJSON.passwordMeta){
                        this.model.dataJSON.passwordMeta = null
                    }
                    this.triggerClosest('onChildChanged', {
                        fieldCode: this.model.fieldCode,
                        value: utils.replace(this.model.dataJSON, {
                            passwordSetAt: undefined,
                            passwordSentViaSMSAt: undefined,
                            passwordSentViaMailAt: undefined,
                        })
                    })
                }
            }
        }
    },
}